function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'pcln-design-system';
import { ChevronDown } from 'pcln-icons';
import Popover from 'pcln-popover';
import MenuList from '../MenuList';
function Menu(_ref) {
  let {
    id,
    buttonNode,
    buttonProps,
    buttonText,
    color,
    width,
    height,
    size,
    trapFocus,
    placement,
    children,
    querySelectorPortal,
    ...props
  } = _ref;
  const MenuContent = _ref2 => {
    let {
      handleClose
    } = _ref2;
    return /*#__PURE__*/React.createElement(MenuList, {
      id: id,
      color: color,
      size: size,
      height: height,
      handleClose: handleClose
    }, children);
  };
  MenuContent.propTypes = {
    handleClose: PropTypes.func
  };
  const onKeyDown = useCallback(evt => {
    const key = evt.key;
    if (key === 'ArrowDown' || key === 'ArrowUp') {
      evt.preventDefault();
      evt.target.click();
    }
  }, []);

  /* eslint-disable react/display-name */
  const ClickableNode = /*#__PURE__*/React.forwardRef((props, ref) => buttonNode ? ( /*#__PURE__*/React.cloneElement(buttonNode, {
    ref,
    onKeyDown,
    ...props
  })) : /*#__PURE__*/React.createElement(Button, _extends({
    IconRight: ChevronDown,
    variation: "link"
  }, props, {
    p: 2
  }, buttonProps, {
    onKeyDown: onKeyDown,
    ref: ref
  }), buttonText));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Popover, _extends({
    "aria-controls": id,
    hideArrow: true,
    idx: id,
    placement: placement ?? 'bottom-start',
    renderContent: MenuContent,
    trapFocus: trapFocus,
    width: width,
    zIndex: 1600,
    querySelectorPortal: `.${querySelectorPortal}`
  }, props), /*#__PURE__*/React.createElement(ClickableNode, null)), querySelectorPortal ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: 0,
      display: 'inline-block'
    },
    className: querySelectorPortal
  }) : null);
}
Menu.displayName = 'Menu';
Menu.propTypes = {
  id: PropTypes.string,
  buttonNode: PropTypes.node,
  buttonProps: PropTypes.shape(Button.propTypes),
  buttonText: PropTypes.node,
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.number,
  size: PropTypes.string,
  trapFocus: PropTypes.bool,
  placement: PropTypes.string,
  children: PropTypes.node,
  querySelectorPortal: PropTypes.string
};
Menu.defaultProps = {
  size: 'singleColumn',
  trapFocus: true,
  width: '650px'
};
export default Menu;